import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface ResultCardSkeletonProps {
  country: "nicaragua" | "costa-rica";
}

const ResultCardSkeleton = ({ country }: ResultCardSkeletonProps) => {
  const countryColor = country === "nicaragua" ? "bg-nicaragua-faded" : "bg-costa-rica-faded";
  
  return (
    <Card className="overflow-hidden border-2">
      <div className={`${countryColor} px-4 py-4 text-center opacity-50`}>
        <Skeleton className="h-8 w-24 mx-auto bg-white/20" />
      </div>
      
      <div className="p-6 space-y-4">
        {/* Primer número grande */}
        <div className="text-center">
          <Skeleton className="h-16 w-20 mx-auto" />
        </div>

        {/* Dato especial */}
        <div className="text-center border-t pt-4 flex flex-col items-center">
          {country === "nicaragua" && (
            <Skeleton className="h-5 w-12 mb-2" />
          )}
          <Skeleton className="rounded-full w-16 h-16" />
        </div>

        {/* Tercer número */}
        <div className="text-center border-t pt-4">
          <Skeleton className="h-5 w-24 mx-auto mb-1" />
          <Skeleton className="h-10 w-16 mx-auto" />
        </div>
      </div>
    </Card>
  );
};

export default ResultCardSkeleton;
